const gaOperationCoreInstanceEn = {
  assignee: 'Assignee',
  confirmTarget: 'Confirm targets',
  gaOperationCore: 'GA Operation Core',
  labelGenerationError: 'An unexpected error occurred',
  labelGenerationFailed: 'Label generation failed',
  labelGenerationStarted: 'Label generation started',
  labelGenerationStartedDetail: 'Started generating labels for {{count}} items',
  labelGenerationSuccess: 'Label generation completed',
  labelGenerationSuccessDetail: 'Generated {{count}} equipment labels',
  labelGenerationTaskNotFound: 'Label generation task was not found',
  labelGenerationTimeout: 'Label generation timed out. Please reload and try again.',
  labelSpecs: {
    customLabel50Faces: 'Custom 50 Labels',
    label10FacesA4: '10 Labels (A4)',
    label12FacesA4: '12 Labels (A4)',
    label21FacesA4: '21 Labels (A4)',
    label24FacesA4: '24 Labels (A4)',
    label65FacesA4: '65 Labels (A4)'
  },
  labelStatusGenerated: 'Generated',
  labelStatusNotGenerated: 'Not generated',
  pdfGenerationTimeout: 'PDF generation timed out. Please try again or reload the status.',
  printOptions: {
    additionalContent: 'Additional Content',
    assetTag: 'Asset Tag',
    equipmentName: 'Equipment Name',
    horizontal: 'Horizontal',
    labelSize: 'Label size',
    layout: 'Layout',
    margin: 'Margin',
    none: 'None',
    paperSize: 'Paper size',
    printSettings: 'Print settings',
    qrCode: 'QR Code',
    vertical: 'Vertical'
  },
  progress: {
    title: 'Progress'
  },
  requestedFor: 'Requested For',
  selectAll: 'Select all',
  selected: 'Selected',
  tabs: {
    data: 'Data',
    detail: 'Detail',
    operationActivity: 'Operation Activity'
  },
  task: {
    approveSuccess: 'Task approved successfully',
    editSuccess: 'Task updated successfully'
  }
};
export default gaOperationCoreInstanceEn;